// extracted by mini-css-extract-plugin
module.exports = {"chatHeaderHeaderContainer":"ChatHeaderContainer_chatHeaderHeaderContainer__1-Hn4","chatHeaderHeader":"ChatHeaderContainer_chatHeaderHeader__I6Kfh"};